module.exports = __webpack_public_path__ + "static/media/e2erecruit.ab61df9a.jpg";